import { useState } from "react";
import { toast } from "sonner";
import { Columns2, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const twoPageSpills = (kit) => {
  const span = {};
  (kit.page_check?.pages || []).forEach((r) => { if (r.status === "overflow") (span[r.block] = span[r.block] || []).push(r); });
  return Object.values(span).filter((rs) => rs.length === 2).map((rs) => rs[0]);
};

export const AllSpreadsButton = ({ kit, reload, disabled }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const rows = twoPageSpills(kit);
  if (!rows.length) return null;
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await http.post(`/kits/${kit.id}/page-two-all`);
      toast.success(`Allowed ${data.allowed} spill(s) to run over 2 pages`);
      await reload();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid="allow-all-spreads-button" disabled={disabled || busy} onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 rounded-sm border border-sky-200 bg-sky-50 px-4 py-2 text-sm font-medium text-sky-800 hover:bg-sky-100 transition-colors disabled:opacity-40">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Columns2 size={15} />} Allow all 2-page spills ({rows.length})
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="allow-all-spreads-dialog" className="bg-white text-[#2B2A26]">
          <AlertDialogHeader>
            <AlertDialogTitle>Let {rows.length} block(s) run over 2 pages?</AlertDialogTitle>
            <AlertDialogDescription>{rows.map((r) => `p.${r.n} ${r.label}`).join(" · ")}. Their second page has no fill rule. Blocks spilling onto 3+ pages aren't included.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="allow-all-spreads-cancel" className="bg-white">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="allow-all-spreads-confirm" onClick={go} className="bg-sky-700 text-white hover:bg-sky-800">Allow all</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
